exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ontology_content[data-v-7db09223]{position:relative;z-index:10;width:calc(200% + 2.5em);margin-top:1em}#iconTextGroup[data-v-7db09223]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#iconTextGroup>*[data-v-7db09223]{margin-right:1rem}.floating_arrow[data-v-7db09223]{right:-3em!important}", ""]);

// exports
